<div class="premium-searchbar">
    <app-smash-input type="text" placeholder="{{ 'PREMIUM_TRANSFER_SEARCH_TRANSFER_DELETED_PLACEHOLDER' | translate }}" [(ngModel)]="search" name="searchValue2">
    </app-smash-input>
</div>


<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1>
                {{ 'PREMIUM_TRANSFER_DELETED_LIST' | translate }}
            </h1>
        </div>
        <div class="premium-card-header-actions">
            <div class="icon icon-refresh" (click)="refreshTransfersDeleted()">
                <i class="icon-smash_remote"></i>
            </div>
        </div>
    </div>
    <ng-container *ngIf="(transfersDeletedLoading$ | async); else transfersDeletedLoaded">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #transfersDeletedLoaded>
        <ng-container *ngIf="(transfersDeleted$ | async).length; else noTransfersDeleted">
            <div class="premium-card-center">
                <app-smash-data-table [data]="(transfersDeleted$ | async)" [searchValue]="search" [columns]='columnsEnabled' saveColumn="transfersDeletedTableConfig" enableMoreOptions='true'
                    enableColumnOptions='false' rowClickable='true' (rowClicked)='viewTransferDetails($event.id)' [paginationEnabled]="true">
                    <ng-template #optionsList let-item>
                        <li (click)="viewTransferDetails(item.id)">
                            {{ 'PREMIUM_TRANSFER_SEE_TRANSFER_DETAILS' | translate }}
                        </li>
                    </ng-template>
                </app-smash-data-table>
            </div>
        </ng-container>
        <ng-template #noTransfersDeleted>
            <div class="premium-card-center-no-content">
                <span class="premium-card-center-no-content-message">
                    {{ 'PREMIUM_TRANSFER_NO_TRANSFER_DELETED' | translate }}
                </span>
            </div>
        </ng-template>
    </ng-template>
</div>
